var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import helpers from '@debbie/common/dist/economy/helpers';
import { VoucherTypeIds } from '@debbie/common/dist/economy/vouchers';
import * as wincentAPI from '@debbie/cortex/dist/api/wincent';
import CreditScore from './CreditScore';
import { useSelector } from 'react-redux';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
const CasePrediction = (props) => {
    var _a, _b;
    const { case: singleCase, interactions, documents, caseVouchers, updates, customer, paymentPlans, } = props;
    const tenant = useSelector(selectTenant);
    const [casePrediction, setCasePrediction] = useState(null);
    const [currentCase, setCurrentCase] = useState(singleCase.caseId);
    const getScore = () => __awaiter(void 0, void 0, void 0, function* () {
        const prediction = yield wincentAPI.getCasePrediction(singleCase.caseId, {
            case: singleCase,
            interactions,
            documents,
            caseVouchers,
            updates,
            customer,
            paymentPlans,
        });
        if (typeof (prediction === null || prediction === void 0 ? void 0 : prediction.score) === 'number') {
            setCasePrediction(prediction.score);
        }
        else {
            setCasePrediction(null);
        }
    });
    const valid = tenant != null &&
        !((_a = tenant.settings) === null || _a === void 0 ? void 0 : _a.aiDisabled) &&
        // Check if there is financial data on the case
        caseVouchers.length > 0 &&
        // Check if there is debtors on the case
        customer.users.length > 0;
    useEffect(() => {
        setCasePrediction(null);
        setCurrentCase(props.case.caseId);
        if (valid)
            getScore();
    }, [props.case.caseId]);
    const balance = -helpers.overview.balance(caseVouchers);
    const deposits = helpers.overview.balance(caseVouchers.filter((v) => v.voucherTypeId === VoucherTypeIds.DEPOSIT));
    if (tenant == null || ((_b = tenant.settings) === null || _b === void 0 ? void 0 : _b.aiDisabled)) {
        return null;
    }
    return casePrediction == null || props.case.caseId != currentCase ? null : (React.createElement(CreditScore, { score: casePrediction, paymentRatio: deposits / (balance + deposits) }));
};
export default CasePrediction;
//# sourceMappingURL=CasePrediction.js.map